var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blade5"}},[_c('blade5a'),_c('blade5b')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }